import { Controller } from "../../Controller";

import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IFiltroModelo, IParcelaModelo } from "../../../Interfaces/Cobranca/Renegociacao/ModeloRenegociacao/ModeloRenegociacaoInterface";
import {
    IDescontos,
    IGerarNovoFluxoRequest,
    IIndicadoresParcelasRenegociacao,
    IRenegociacao,
    IValidaProdutoCasoRenegociacao,
} from "../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";

import {
    CalcularDescontosRenegociacaoService,
    CalcularNovoFluxoService,
    CarregarModelosRenegociacaoService,
    CarregarParcelasModeloRenegociacaoService,
    FinalizarAcordoRenegociacaoService,
    ValidaProdutoECasoParaRenegociacaoService,
} from "../../../Services/Cobranca/Renegociacao/RenegociacaoServices";

export const CalcularDescontosRenegociacaoController = (
    idCaso: number,
    parcelas: Array<IParcelaBoletos>,
    descontos: IDescontos
) =>
    Controller(
        CalcularDescontosRenegociacaoService(idCaso, parcelas, descontos)
    );

export const CarregarModelosRenegociacaoController = (idCaso: number) =>
    Controller(CarregarModelosRenegociacaoService(idCaso));

export const CarregarParcelasModeloRenegociacaoController = (
    idModelo: number,
    DiaPrimeiraParc: number,
    indicadores: IIndicadoresParcelasRenegociacao,
    valorEntrada?: number,
    dtEntrada?: string
) =>
    Controller(
        CarregarParcelasModeloRenegociacaoService(
            idModelo,
            DiaPrimeiraParc,
            indicadores,
            valorEntrada,
            dtEntrada
        )
    );

export const CalcularNovoFluxoController = (
    parcelas: Array<IParcelaModelo>,
    request: IGerarNovoFluxoRequest
) => Controller(CalcularNovoFluxoService(parcelas, request));

export const FinalizarAcordoRenegociacaoController = (
    renegociacaoConfig: IRenegociacao,
    renegociacaoFiltro: IFiltroModelo
) => Controller(FinalizarAcordoRenegociacaoService(renegociacaoConfig, renegociacaoFiltro));
export const ValidaProdutoECasoParaRenegociacaoController = (
    validaReneg: IValidaProdutoCasoRenegociacao
) => Controller(ValidaProdutoECasoParaRenegociacaoService(validaReneg));
